export const DOSU_COLORS = 'dosu_colors';
